import { IsolatedScanIMU } from "../types/types";
import { genericRequest, isolatedScanIMURoute } from "./service"

export const addIsolatedScanImu = async (isolatedScanImu: IsolatedScanIMU, sectionScanId: number) => {
  const body = JSON.stringify(isolatedScanImu)
  return await genericRequest({ url: `${isolatedScanIMURoute}/${sectionScanId}`, method: "POST", body: body })
}

export const getIsolatedScanImu = async (sectionScanId: number) => {
  return await genericRequest({ url: `${isolatedScanIMURoute}/isolated_scan_imus/${sectionScanId}`, method: "GET" })
}
